// extracted by css-extract-rspack-plugin
export default {"diffEntryHeader":"AutomatedReviewDiffEntry-module__diffEntryHeader__jpwSXXd","automatedReviewDiff":"AutomatedReviewDiffEntry-module__automatedReviewDiff__obcQSFa"};